// import LegacyDefaulImport from '@elliemae/ds-legacy-date-range-selector';

// export {
//   DateRangeRecurrenceSelectorWithSchema,
//   DSDateRangeSelector,
//   CUSTOM_OPTION_VALUE,
// } from '@elliemae/ds-legacy-date-range-selector';

// export default LegacyDefaulImport;
export * from '@elliemae/ds-legacy-date-range-selector';
